<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-hotels-edit-rooms">
            <div class="hotels-wrap">
              <HotelsSideMenu />
              <div class="hotels-content">
                <div class="lds-ring" v-if="!isLoad">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                <form v-if="isLoad">
                  <div class="page-title">
                    <h2>Rooms</h2>
                    <div class="languages-group languages-group_top-head">
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="EN">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">English</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="RU">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-rus ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Russian</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="DE">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Deutch</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="ES">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Spanish</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="FR">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">French</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="PT">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Portuguese</span>
                      </label>
                      <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                        <input type="radio" name="lanuage" v-model="lang" value="NL">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-deu ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                          </svg>
                        </div>
                        <span class="np-detail-collapse__lang__text">Dutch</span>
                      </label>
                    </div>
                  </div>
                  <div class="edit-rooms">
                    <div class="edit-rooms__title">Single</div>
                    <div class="edit-rooms-section" v-for="(item, index) in single" :key="index">
                      <div class="edit-rooms-section__choice">
                        <div
                            class="form-control-group form-control-group--labeled form-control-group_edit"><span
                            class="form-control-label">Special name</span>
                          <div :class="['form-control-wrap', { 'is-error' : item.error }]">
                            <input type="text" class="form-control"
                                   v-model="item.names[lang]" @change="isEdit = true"
                                   @focus="item.error = false">
                          </div>
                        </div>
                        <div class="list-persons">
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A') ? item.accommodations.filter(room => !(room === '1A')) : item.accommodations.concat('1A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1C') ? item.accommodations.filter(room => !(room === '1A1C')) : item.accommodations.concat('1A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1T') ? item.accommodations.filter(room => !(room === '1T')) : item.accommodations.concat('1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                        </div>
                      </div>
                      <div style="margin-top: 8px; min-width: 100px; margin-right: 5px;" v-if="oneBedInTwinAvailable === true">
                        <Checkbox label="1 Bed In Twin" v-model="item.oneBedInTwin"/>
                      </div>
                      <div class="edit-rooms-section__actions">
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
									entity: 'Room',
									name: 'this',
									handler: removeRoom,
									id: { index, mode: 'SINGLE' }
								})">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div class="edit-rooms__btn">
                      <button type="button" class="btn btn--rounded2 btn--green"
                              @click="addRoom('SINGLE')"><span>Add Room</span>
                      </button>
                    </div>
                  </div>
                  <div class="edit-rooms">
                    <div class="edit-rooms__title">DOUBLE/TWIN</div>
                    <div class="edit-rooms-section" v-for="(item, index) in double" :key="index">
                      <div class="edit-rooms-section__choice">
                        <div
                            class="form-control-group form-control-group--labeled form-control-group_edit"><span
                            class="form-control-label">Special name</span>
                          <div :class="['form-control-wrap', { 'is-error' : item.error }]">
                            <input type="text" class="form-control"
                                   v-model="item.names[lang]" @change="isEdit = true"
                                   @focus="item.error = false">
                          </div>
                        </div>
                        <div class="list-persons">
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A') ? item.accommodations.filter(room => !(room === '2A')) : item.accommodations.concat('2A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T') ? item.accommodations.filter(room => !(room === '2A1T')) : item.accommodations.concat('2A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1T') ? item.accommodations.filter(room => !(room === '1A1T')) : item.accommodations.concat('1A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A2T') ? item.accommodations.filter(room => !(room === '1A2T')) : item.accommodations.concat('1A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A2C') ? item.accommodations.filter(room => !(room === '1A2C')) : item.accommodations.concat('1A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1C') ? item.accommodations.filter(room => !(room === '2A1C')) : item.accommodations.concat('2A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1T1C') ? item.accommodations.filter(room => !(room === '1A1T1C')) : item.accommodations.concat('1A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2T1C') ? item.accommodations.filter(room => !(room === '2T1C')) : item.accommodations.concat('2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3T') ? item.accommodations.filter(room => !(room === '3T')) : item.accommodations.concat('3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2T') ? item.accommodations.filter(room => !(room === '2T')) : item.accommodations.concat('2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A') ? item.accommodations.filter(room => !(room === '3A')) : item.accommodations.concat('3A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                        </div>
                      </div>
                      <div style="margin-top: 8px; min-width: 100px; margin-right: 5px;" v-if="oneBedInTwinAvailable === true">
                        <Checkbox label="1 Bed In Twin" v-model="item.oneBedInTwin"/>
                      </div>
                      <div class="edit-rooms-section__actions">
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
									entity: 'Room',
									name: 'this',
									handler: removeRoom,
									id: { index, mode: 'DOUBLE' }
								})">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="edit-rooms__btn">
                      <button type="button" class="btn btn--rounded2 btn--green"
                              @click="addRoom('DOUBLE')"><span>Add Room</span>
                      </button>
                    </div>
                  </div>
                  <div class="edit-rooms">
                    <div class="edit-rooms__title">FAMILY SUITE</div>
                    <div class="edit-rooms-section" v-for="(item, index) in family" :key="index">
                      <div class="edit-rooms-section__choice">
                        <div
                            class="form-control-group form-control-group--labeled form-control-group_edit"><span
                            class="form-control-label">Special name</span>
                          <div :class="['form-control-wrap', { 'is-error' : item.error }]">
                            <input type="text" class="form-control"
                                   v-model="item.names[lang]" @change="isEdit = true"
                                   @focus="item.error = false">
                          </div>
                        </div>
                        <div class="list-persons">
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A2T1C') ? item.accommodations.filter(room => !(room === '1A2T1C')) : item.accommodations.concat('1A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1T2C') ? item.accommodations.filter(room => !(room === '1A1T2C')) : item.accommodations.concat('1A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T') ? item.accommodations.filter(room => !(room === '2A2T')) : item.accommodations.concat('2A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2C') ? item.accommodations.filter(room => !(room === '2A2C')) : item.accommodations.concat('2A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A3T') ? item.accommodations.filter(room => !(room === '2A3T')) : item.accommodations.concat('2A3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A3C') ? item.accommodations.filter(room => !(room === '2A3C')) : item.accommodations.concat('2A3C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A3C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T1C') ? item.accommodations.filter(room => !(room === '2A1T1C')) : item.accommodations.concat('2A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T2C') ? item.accommodations.filter(room => !(room === '2A2T2C')) : item.accommodations.concat('2A2T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1T') ? item.accommodations.filter(room => !(room === '3A1T')) : item.accommodations.concat('3A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1T')">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1C') ? item.accommodations.filter(room => !(room === '3A1C')) : item.accommodations.concat('3A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A2T') ? item.accommodations.filter(room => !(room === '3A2T')) : item.accommodations.concat('3A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A2C') ? item.accommodations.filter(room => !(room === '3A2C')) : item.accommodations.concat('3A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1T1C') ? item.accommodations.filter(room => !(room === '3A1T1C')) : item.accommodations.concat('3A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T1C') ? item.accommodations.filter(room => !(room === '2A2T1C')) : item.accommodations.concat('2A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T2C') ? item.accommodations.filter(room => !(room === '2A1T2C')) : item.accommodations.concat('2A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A') ? item.accommodations.filter(room => !(room === '4A')) : item.accommodations.concat('4A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg><svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg><svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1T') ? item.accommodations.filter(room => !(room === '4A1T')) : item.accommodations.concat('4A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A2T') ? item.accommodations.filter(room => !(room === '4A2T')) : item.accommodations.concat('4A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1C') ? item.accommodations.filter(room => !(room === '4A1C')) : item.accommodations.concat('4A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A2C') ? item.accommodations.filter(room => !(room === '4A2C')) : item.accommodations.concat('4A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1T1C') ? item.accommodations.filter(room => !(room === '4A1T1C')) : item.accommodations.concat('4A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                        </div>
                      </div>
                      <div class="edit-rooms-section__actions">
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
									entity: 'Room',
									name: 'this',
									handler: removeRoom,
									id: { index, mode: 'FAMILY' }
								})">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="edit-rooms__btn">
                      <button type="button" class="btn btn--rounded2 btn--green"
                              @click="addRoom('FAMILY')"><span>Add Room</span>
                      </button>
                    </div>
                  </div>

                  <div class="edit-rooms">
                    <div class="edit-rooms__title">SPECIFIC ROOM TYPES</div>
                    <div class="edit-rooms-section" v-for="(item, index) in specific" :key="index">
                      <div class="edit-rooms-section__choice">
                        <div
                            class="form-control-group form-control-group--labeled form-control-group_edit"><span
                            class="form-control-label">Special name</span>
                          <div :class="['form-control-wrap', { 'is-error' : item.error }]">
                            <input type="text" class="form-control"
                                   v-model="item.names[lang]"
                                   @focus="item.error = false">
                          </div>
                        </div>
                        <div class="list-persons">
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A') ? item.accommodations.filter(room => !(room === '2A')) : item.accommodations.concat('2A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T') ? item.accommodations.filter(room => !(room === '2A1T')) : item.accommodations.concat('2A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A2T') ? item.accommodations.filter(room => !(room === '1A2T')) : item.accommodations.concat('1A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1C') ? item.accommodations.filter(room => !(room === '2A1C')) : item.accommodations.concat('2A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1T1C') ? item.accommodations.filter(room => !(room === '1A1T1C')) : item.accommodations.concat('1A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A2T1C') ? item.accommodations.filter(room => !(room === '1A2T1C')) : item.accommodations.concat('1A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1A1T2C') ? item.accommodations.filter(room => !(room === '1A1T2C')) : item.accommodations.concat('1A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T') ? item.accommodations.filter(room => !(room === '2A2T')) : item.accommodations.concat('2A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2C') ? item.accommodations.filter(room => !(room === '2A2C')) : item.accommodations.concat('2A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A') ? item.accommodations.filter(room => !(room === '4A')) : item.accommodations.concat('4A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A3T') ? item.accommodations.filter(room => !(room === '2A3T')) : item.accommodations.concat('2A3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A4T') ? item.accommodations.filter(room => !(room === '2A4T')) : item.accommodations.concat('2A4T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A4T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A3C') ? item.accommodations.filter(room => !(room === '2A3C')) : item.accommodations.concat('2A3C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A3C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T1C') ? item.accommodations.filter(room => !(room === '2A1T1C')) : item.accommodations.concat('2A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T1C') ? item.accommodations.filter(room => !(room === '2A2T1C')) : item.accommodations.concat('2A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A2T2C') ? item.accommodations.filter(room => !(room === '2A2T2C')) : item.accommodations.concat('2A2T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A2T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2A1T2C') ? item.accommodations.filter(room => !(room === '2A1T2C')) : item.accommodations.concat('2A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A') ? item.accommodations.filter(room => !(room === '3A')) : item.accommodations.concat('3A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1T') ? item.accommodations.filter(room => !(room === '3A1T')) : item.accommodations.concat('3A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1C') ? item.accommodations.filter(room => !(room === '3A1C')) : item.accommodations.concat('3A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A2T') ? item.accommodations.filter(room => !(room === '3A2T')) : item.accommodations.concat('3A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A2C') ? item.accommodations.filter(room => !(room === '3A2C')) : item.accommodations.concat('3A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1T1C') ? item.accommodations.filter(room => !(room === '3A1T1C')) : item.accommodations.concat('3A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A2T1C') ? item.accommodations.filter(room => !(room === '3A2T1C')) : item.accommodations.concat('3A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3A1T2C') ? item.accommodations.filter(room => !(room === '3A1T2C')) : item.accommodations.concat('3A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>

                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1T') ? item.accommodations.filter(room => !(room === '4A1T')) : item.accommodations.concat('4A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A2T') ? item.accommodations.filter(room => !(room === '4A2T')) : item.accommodations.concat('4A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A3T') ? item.accommodations.filter(room => !(room === '4A3T')) : item.accommodations.concat('4A3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A2T1C') ? item.accommodations.filter(room => !(room === '4A2T1C')) : item.accommodations.concat('4A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1T2C') ? item.accommodations.filter(room => !(room === '4A1T2C')) : item.accommodations.concat('4A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A3C') ? item.accommodations.filter(room => !(room === '4A3C')) : item.accommodations.concat('4A3C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A3C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1C') ? item.accommodations.filter(room => !(room === '4A1C')) : item.accommodations.concat('4A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A2C') ? item.accommodations.filter(room => !(room === '4A2C')) : item.accommodations.concat('4A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('4A1T1C') ? item.accommodations.filter(room => !(room === '4A1T1C')) : item.accommodations.concat('4A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('4A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A') ? item.accommodations.filter(room => !(room === '5A')) : item.accommodations.concat('5A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A1T') ? item.accommodations.filter(room => !(room === '5A1T')) : item.accommodations.concat('5A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A1C') ? item.accommodations.filter(room => !(room === '5A1C')) : item.accommodations.concat('5A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A2T') ? item.accommodations.filter(room => !(room === '5A2T')) : item.accommodations.concat('5A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A1T1C') ? item.accommodations.filter(room => !(room === '5A1T1C')) : item.accommodations.concat('5A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                 <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A2C') ? item.accommodations.filter(room => !(room === '5A2C')) : item.accommodations.concat('5A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                 <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A3T') ? item.accommodations.filter(room => !(room === '5A3T')) : item.accommodations.concat('5A3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A2T1C') ? item.accommodations.filter(room => !(room === '5A2T1C')) : item.accommodations.concat('5A2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A1T2C') ? item.accommodations.filter(room => !(room === '5A1T2C')) : item.accommodations.concat('5A1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('5A3C') ? item.accommodations.filter(room => !(room === '5A3C')) : item.accommodations.concat('5A3C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('5A3C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A') ? item.accommodations.filter(room => !(room === '6A')) : item.accommodations.concat('6A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                               <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A1T') ? item.accommodations.filter(room => !(room === '6A1T')) : item.accommodations.concat('6A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                               <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A1C') ? item.accommodations.filter(room => !(room === '6A1C')) : item.accommodations.concat('6A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A2T') ? item.accommodations.filter(room => !(room === '6A2T')) : item.accommodations.concat('6A2T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A2T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A1T1C') ? item.accommodations.filter(room => !(room === '6A1T1C')) : item.accommodations.concat('6A1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('6A2C') ? item.accommodations.filter(room => !(room === '6A2C')) : item.accommodations.concat('6A2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('6A2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('7A') ? item.accommodations.filter(room => !(room === '7A')) : item.accommodations.concat('7A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('7A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                               <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('7A1T') ? item.accommodations.filter(room => !(room === '7A1T')) : item.accommodations.concat('7A1T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('7A1T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                               <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('7A1C') ? item.accommodations.filter(room => !(room === '7A1C')) : item.accommodations.concat('7A1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('7A1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                               <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('8A') ? item.accommodations.filter(room => !(room === '8A')) : item.accommodations.concat('8A')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('8A')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-adult">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3C') ? item.accommodations.filter(room => !(room === '3C')) : item.accommodations.concat('3C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2C') ? item.accommodations.filter(room => !(room === '2C')) : item.accommodations.concat('2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('3T') ? item.accommodations.filter(room => !(room === '3T')) : item.accommodations.concat('3T')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('3T')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('2T1C') ? item.accommodations.filter(room => !(room === '2T1C')) : item.accommodations.concat('2T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('2T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1T2C') ? item.accommodations.filter(room => !(room === '1T2C')) : item.accommodations.concat('1T2C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1T2C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">
                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>
                          <label
                              class="form-control-checkbox-person form-control-checkbox-person_2"
                              @click.prevent="item.accommodations = item.accommodations.includes('1T1C') ? item.accommodations.filter(room => !(room === '1T1C')) : item.accommodations.concat('1T1C')">
                            <input type="checkbox"
                                   :checked="item.accommodations.includes('1T1C')"
                                   @change="isEdit = true">
                            <span class="form-control-checkbox-person__box">

                                <svg width="1em" height="1em" class="icon icon-teenager ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg width="1em" height="1em" class="icon icon-child ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </span>
                          </label>


                        </div>
                      </div>
                      <div class="edit-rooms-section__actions">
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
									entity: 'Room',
									name: 'this',
									handler: removeRoom,
									id: { index, mode: 'SPECIFIC' }
								})">>
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="edit-rooms__btn">
                      <button type="button" class="btn btn--rounded2 btn--green"
                              @click="addRoom('SPECIFIC')"><span>Add Room</span>
                      </button>
                    </div>
                  </div>
                  <div class="edit-rooms__btn-edit">
                    <button type="button" class="btn btn--green" @click="updatePopup = true"><span>Update</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="modal-wrapper" v-if="updatePopup">
              <div class="modal-backdrop"></div>
              <div class="modal-inner">
                <div class="edit-popup edit-popup--history">
                  <div class="edit-popup__header">
                    <div class="edit-popup__title">
                      Update History
                    </div>
                    <div class="edit-popup__close" @click="updatePopup = false">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </div>
                  </div>
                  <form action="javascript:void(0)" class="edit-popup__inner">
                    <div class="form-control-group"><span
                        class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                      <div class="form-control-wrap">
                        <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                      </div>
                      <div class="edit-popup__error-text">
                        <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                      </div>
                    </div>
                    <div class="options-additional__btns">
                      <button type="button" class="btn btn--silver" @click="updatePopup = false">
                        <span>Cancel</span>
                      </button>
                      <button type="submit" class="btn btn--green edit-popup__submit"
                              :disabled="descriptionUpdate.length < 6"
                              @click="updateHotelsRoomsHandler">
                        <span>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  getHotelsRoomsV2,
  updateHotelsRoomsV2,
  getHotelAdvanced
} from '@/utilites/api'
import Checkbox from "@/components/UI/Checkbox/Checkbox.vue";
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  components: {HotelsSideMenu, Checkbox},
  data() {
    return {
      rooms: [],
      isLoad: false,
      updatePopup: false,
      isEdit: false,
      descriptionUpdate: '',
      lang: 'EN',
      hotelName: '',
      oneBedInTwinAvailable: false
    }
  },
  props: ['user'],
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  created() {
    getHotelAdvanced(this.$route.params.id)
        .then(res => {
          this.hotelName = res.names.EN
        })
  },
  methods: {
    addRoom(mode) {
      this.rooms = this.rooms.concat({
        hotelId: +this.$route.params.id,
        type: mode,
        names: {
          EN: '',
          RU: '',
          DE: '',
          ES: '',
          FR: '',
          PT: '',
          NL: '',
        },
        accommodations: []
      })
      this.isEdit = true
    },
    removeRoom(data) {
      let rooms = this.rooms.filter((item) => !(item.type === data.mode))
      rooms = rooms.concat(this.rooms.filter((item) => item.type === data.mode).filter((_, i) => !(i === data.index)))
      this.rooms = rooms
      this.isEdit = true
    },
    checkErrorsRoom() {
      let error = false
      this.rooms = this.rooms.map(item => {
        if (!item.names[this.lang]) {
          error = true
          return ({
            ...item,
            error: true
          })
        }
        return item
      })
      return error
    },
    updateHotelsRoomsHandler() {
      if (!this.checkErrorsRoom()) {
        updateHotelsRoomsV2({
          rooms: this.rooms,
          history: {
            hotelId: +this.$route.params.id,
            userId: this.user.data.id,
            description: this.descriptionUpdate
          }
        }, this.$route.params.id)
            .then(res => {
              this.isEdit = false
              this.$emit('confirmed')
              this.descriptionUpdate = ''
              this.updatePopup = false
            })
      } else {
        this.descriptionUpdate = ''
        this.updatePopup = false
      }
    },
    waitSaveTiming() {
      const saveFun = () => {
        this.updatePopup = true;
      }
      const waitFun = () => {
        this.waitSaveTiming();
      }
      setTimeout(() => {
        this.$emit('waitSaveHandler', [saveFun, waitFun]);
      }, 10 * 60 * 1000)
    },
  },
  mounted() {
    const id = this.$route.params.id
    Promise.all([getHotelsRoomsV2(id)])
        .then(res => {
          this.rooms = res[0].rooms
          this.oneBedInTwinAvailable = res[0].oneBedInTwinAvailable || false;
          this.isLoad = true
        })
  },
  computed: {
    single() {
      return this.rooms.filter(item => item.type === 'SINGLE')
    },
    double() {
      return this.rooms.filter(item => item.type === 'DOUBLE')
    },
    family() {
      return this.rooms.filter(item => item.type === 'FAMILY')
    },
    specific() {
      return this.rooms.filter(item => item.type === 'SPECIFIC')
    }
  },
  watch: {
    isEdit(val) {
      if (val) this.waitSaveTiming();
    },
  },
}
</script>
